import React from 'react';
import { IconButton, IconMenu, MenuItem } from 'material-ui';


const TabLabelWithMenu = props => {
  const {
    menuOpen,
    onMenuClose,
    onMenuOpen,
    menuData,
    labelText,
    value,
  } = props;
  return (
    <div className="flex-center" onMouseOver={onMenuOpen(value)} onMouseLeave={onMenuClose(value)}>
      {/*<IconMenu*/}
      {/*  onRequestChange={onMenuClose(value)}*/}
      {/*  style={{ top: '16px' }}*/}
      {/*  iconButtonElement={*/}
      {/*    <IconButton style={{ display: 'none' }} iconClassName="icon-placeholder" />*/}
      {/*  }*/}
      {/*  open={menuOpen}*/}
      {/*  anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}*/}
      {/*  targetOrigin={{ horizontal: 'left', vertical: 'top' }}*/}
      {/*>*/}
      {/*  {menuData.map((obj, i, length) => (*/}
      {/*    <MenuItem*/}
      {/*      key={obj.text}*/}
      {/*      style={i < length - 1 ? { borderBottom: '1px solid #e0e0e0' } : {}}*/}
      {/*      leftIcon={<obj.Icon color={obj.iconColor || 'rgba(0, 0, 0, 0.87)'} />}*/}
      {/*      primaryText={obj.text}*/}
      {/*      onClick={obj.onClick}*/}
      {/*    />*/}
      {/*  ))}*/}
      {/*</IconMenu>*/}
      {labelText}
    </div>
  );
};

export default TabLabelWithMenu;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/template-draft-toolbar/tab-with-menu.jsx